import { AlgoliaSearch } from "@/services/algoliaSearch"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { categoryGroupFilter } from "../utils/filters"

/**
 * Query for searching products.
 */
export const queryAlgoliaProductFacets = {
  /**
   * Resolver function for productSearch query.
   * @param {any} parent - The parent resolver.
   * @param {Object} args - The query arguments.
   * @param {Object} context - The resolver context.
   * @param {Object} info - The query info.
   * @returns {Object} - The search results.
   */
  async algoliaProductFacets(parent, args, context, info) {
    const { categoryId } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.PRODUCTS,
      operation: Operations.READ,
    })

    const algoliaClient = AlgoliaSearch.client()

    const productsFacetsResponse = await algoliaClient.searchSingleIndex({
      indexName: "products",
      searchParams: {
        facets: ["*"],
        maxValuesPerFacet: 1000,
        ...(categoryId && { filters: categoryGroupFilter(categoryId) }),
      },
    })

    const facets = getFacets(productsFacetsResponse?.facets)

    return facets
  },
}

const getFacets = (facets) => {
  if (!facets || facets.length === 0) return []

  const mappedFacets = []

  for (const [key, value] of Object.entries(facets)) {
    const keyFacet = []
    for (const [valueKey, valueAmount] of Object.entries(value)) {
      keyFacet.push({
        option: valueKey,
        amount: valueAmount,
      })
    }
    mappedFacets.push({ key, values: keyFacet })
  }

  return mappedFacets
}
